import {
  AudioHighlightMetadataType,
  ReasonSummaryAudioHighlightMetadata,
} from '@modules/feedback/components/AudioType/types';
import { getStartEndTimeFromAudioSummaryMetadata } from '@modules/feedback/components/AudioType/utils';
import { PredictionLabelType } from '@modules/feedback/types';
import { SummaryMessageUnit } from 'generated/graphql';
import { AudioConversationMessage } from 'v2/core/entities/feedback/content';
import { MatchedFeedbackMetadataCommon } from 'v2/core/entities/labels';
import { UUID } from 'v2/core/entities/uuid';

export const mapReasonSummaryHighlightMetadata = (
  labelMetadata: MatchedFeedbackMetadataCommon,
  keywordSummaryUnitsMap: Map<UUID, SummaryMessageUnit[]>,
  reasonSummaryTextMap: Map<
    UUID,
    { summaryText: string; summaryStartTime: number }[]
  >,
  audioConversation: AudioConversationMessage[],
): ReasonSummaryAudioHighlightMetadata | null => {
  if (
    labelMetadata.labelType !== PredictionLabelType.Reason ||
    !labelMetadata.keywordSummaryLabelID
  ) {
    return null;
  }

  const keywordSummaryUnits = keywordSummaryUnitsMap.get(
    labelMetadata.keywordSummaryLabelID,
  );

  if (!keywordSummaryUnits?.length) {
    return null;
  }

  const reasonSummaryTexts = reasonSummaryTextMap.get(labelMetadata.id ?? '');

  if (!reasonSummaryTexts?.length) {
    return null;
  }

  const reasonSummary = keywordSummaryUnits[labelMetadata.msgIDx ?? 0];

  if (!reasonSummary) {
    return null;
  }

  const { startTime, endTime } = getStartEndTimeFromAudioSummaryMetadata(
    reasonSummary.metadata,
    audioConversation,
  );

  const firstSummaryLocation = reasonSummary.metadata?.location?.[0];

  const summaryIndex = reasonSummaryTexts.findIndex(
    (summary) => summary.summaryText === reasonSummary.text,
  );

  const reasonHighlightMetadata: ReasonSummaryAudioHighlightMetadata = {
    labelID: labelMetadata.id ?? '',
    labelDisplayName: labelMetadata.labelText ?? '',
    type: AudioHighlightMetadataType.ReasonSummary,
    keywordID: labelMetadata.keywordSummaryLabelID ?? '',
    summaryText: reasonSummary.text,
    summaryIndex,
    summaryCount: reasonSummaryTexts.length,
    startTime,
    endTime,
    msgIndex:
      firstSummaryLocation?.__typename === 'IndexTypeConversation'
        ? firstSummaryLocation.messageIndex
        : 0,
  };

  return reasonHighlightMetadata;
};
